<script lang="ts">
    import {
        Tooltip,
        StructuredList, 
        StructuredListHead, 
        StructuredListBody, 
        StructuredListRow, 
        StructuredListCell,
    } from "carbon-components-svelte"
    import SelectBuilding from "./SelectBuilding.svelte";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant, selectedBuilding, gates} from "../stores";
    import type { Building } from "../models/Building";
    import { onMount } from "svelte";
    import type { Gate } from "../models/Gate";
    import type { Tenant } from "../models/Tenant";
    import Legend from "./Legend.svelte";
    import {Helpers} from "../utilities/Helpers"

    export let requests: Requests;
    let building: Building;
    let buildingGates: Gate[] = [];
    let tenant: Tenant;

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
        })
        selectedBuilding.subscribe((value) => {
            building = value;
        })
        gates.subscribe((value) => {          
            buildingGates = value;
        })
    })

</script>

<SelectBuilding requests={requests} />
{#if building}
    {#if building.id === ""}
        <h6 class="margin-top-32">Selezionare un building</h6>
    {:else}
        {#if buildingGates.length > 0}
        <div class="title-and-legend-container">
            <h4 class="margin-top-64 margin-bottom-16">
                Varchi del building {building.name}
            </h4>
            <Legend isBookings={false} greenText="Attivo" redText="Disabilitato" yellowText=""/>
        </div>
        <StructuredList condensed>
            <StructuredListHead>
            <StructuredListRow head class="header-row">
                <StructuredListCell head>Nome</StructuredListCell>
                <StructuredListCell head>Tipo di varco</StructuredListCell>
                <StructuredListCell head>Stato</StructuredListCell>
                <StructuredListCell head>Policies</StructuredListCell>
            </StructuredListRow>
            </StructuredListHead>
            <StructuredListBody>
                {#each buildingGates as gate, index}
                <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                    <StructuredListCell>{gate.name}</StructuredListCell>
                    <StructuredListCell>{gate.type}</StructuredListCell>           
                    <StructuredListCell>
                    {#if gate.status === "INACTIVE"}
                    <span class="state-pill error"></span>
                    {:else if gate.status === "ACTIVE"}
                    <span class="state-pill good"></span>
                    {/if}
                    </StructuredListCell>
                    <StructuredListCell>
                        {#each gate.policies as policy, index}
                        <Tooltip triggerText={policy}>
                            <p id="tooltip-body">
                              {Helpers.getPolicyDescription(policy)}
                            </p>
                        </Tooltip>
                        {/each}
                    </StructuredListCell>
                </StructuredListRow>
                {/each}      
            </StructuredListBody>
        </StructuredList>
        {:else}
        <h6 class="margin-top-32">Nessun varco presente</h6>
        {/if}
    {/if}
{/if}